import { render } from "./DocumentsSection.vue?vue&type=template&id=b10873c2"
import script from "./DocumentsSection.vue?vue&type=script&lang=js"
export * from "./DocumentsSection.vue?vue&type=script&lang=js"

import "./DocumentsSection.vue?vue&type=style&index=0&id=b10873c2&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__